import { ReactComponent as BackIcon } from "@preownedfront/lib-reowds/icons/24/arrow-left.svg";
import { ReactComponent as DismissIcon } from "@preownedfront/lib-reowds/icons/24/dismiss.svg";
import { ReactComponent as SearchIcon } from "@preownedfront/lib-reowds/icons/24/search.svg";
import { t } from "i18next";
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as ResellLogoWM } from "src/assets/icons/wm-zara-pre-owned-new-logo.svg";
import { PRODUCT_NICKNAME } from 'src/constants/UrlConstants';
import { useScrollDirection } from "src/hooks/Utils/useScrollDirection";
import { ProfileShortcut } from 'src/pages/Profile/ProfileShortcut/ProfileShortcut';
import { ROUTE_PATHS } from 'src/utils/constants';
import { navigateToZaraHome } from "src/utils/navigation";
import useResponsive from 'src/utils/useResponsive';
import { getClassnames } from 'src/utils/utils';
import { getLogoComponent, HeaderProps } from '../utils/Navigation.utils';
import CartCounterLink from "src/components/CartCounter/CartCounterLink";
import "./preowned-header.scss";

const PreownedHeader = ({wrapperProps}: HeaderProps) => {
  const { pathname, state } = useLocation();
  const productNickname = state?.[PRODUCT_NICKNAME];
  const { WSXS, WS, WSXL } = useResponsive();
  const { whiteBackGround, showBackIcon, handleBackClick, handleDimissClick, onLogoClickHandled, } = wrapperProps;
  const { scrollDirection } = useScrollDirection();

  const classNameNavBar = getClassnames({
    ["nav-main-menu"]: pathname?.includes(`${ROUTE_PATHS.PRODUCTS}/`) && WS,
    ["nav"]: true,
    ["nav-background"]: whiteBackGround && WS,
    ["wm"]: WSXS,
    [scrollDirection]: WSXS,
  });

  const showIconClass = getClassnames({
    ["nav__icons__header-icon__svg"]: true,
    ["icon-hidden"]: !!productNickname,
  });

  const iconClassName = getClassnames({
    [`nav__icons__header-icon__svg`]: !WSXS,
    [`nav__icons__wm-icon__svg__close`]: WSXS,
  });

  const LogoResell = WSXS ? ResellLogoWM : getLogoComponent("preowned", WSXL);

  const iconMap = {
    back:
        <BackIcon
          className={showIconClass}
        />,
    dismiss:
        <DismissIcon
          className={iconClassName}
        />
  };

  const Icon = WSXS ? iconMap.dismiss : showBackIcon() ? iconMap.back : iconMap.dismiss;

  const isProductPage = pathname?.includes(`${ROUTE_PATHS.PRODUCTS}/`) && !pathname?.includes(ROUTE_PATHS.BUNDLE);

  return (
    <nav className={classNameNavBar} aria-label={t("navigation_main")}>
      <ul className="nav__header">
        <li className="nav__icons__icon">
          <button 
            onClick={() => {
              if (showBackIcon()) {
                if (!productNickname) handleBackClick();
              } else {
                if (WSXS) {
                  navigateToZaraHome();
                } else {
                  handleDimissClick();
                }
              }
            }}
            aria-label={showBackIcon() ? t("nav_icons_back") : t("nav-pds__icons__wm-icon__svg__close")}>
            {Icon}
          </button>
        </li>
        <li className="nav__icons__icon">
          <div className="nav__icons__logo-text">
            <button onClick={onLogoClickHandled} aria-label={t("nav-pds__icons__icon")} >
              <LogoResell />
            </button>
            {isProductPage && (
              <div className="nav__icons__logo-text__informative">
                <p className="pds-body-s-highlight"> {t("informative-text-grid-1")}</p>
                <p className="pds-body-s-highlight"> {t("informative-text-grid-2")}</p>
              </div>
            )}
          </div>
        </li>
      </ul>
      <ul className="nav__icons">
        <li>
          <Link className="nav__icons__icon" to={ROUTE_PATHS.SEARCH} aria-label={t("navigation_search")}>
            <SearchIcon className="nav__icons__wm-icon__svg" />
          </Link>
        </li>
        <li>
          <ProfileShortcut className="nav__icons__icon"
          />
        </li>
        <li>
          <CartCounterLink />
        </li>
      </ul>
    </nav>
  );
};

export default PreownedHeader;
